import { Button, Tooltip } from '@material-ui/core';
import { Replay } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import React from 'react';

import { colors } from 'src/themes/colors';

import { CalendarModalTestID, DeleteCalendarData } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalDeleteIcon } from './CalendarModalDeleteIcon';

interface Props {
  profileId: string;
  profileName: string;
  uuid: string;
  onDeleteClick: (DeleteCalendarData: DeleteCalendarData) => void;
  onSyncClick: () => void;
  working: boolean;
}

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    transform: 'translate3d(0, 0, 0) !important',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    maxWidth: 370,
    padding: 12,
    fontSize: '14px',
    fontWeight: 800,
    backgroundColor: colors.black2,
    color: colors.white1,
    borderRadius: 4,
  },
}))(Tooltip);

export const CalendarModalProfileHeadingButtonGrp: React.FC<Props> = ({
  profileId,
  profileName,
  uuid,
  onDeleteClick,
  onSyncClick,
  working,
}) => {
  const classes = useStyles();

  const handleDeleteClick = () => {
    onDeleteClick({ uuid, profileId, profileName });
  };

  return (
    <div
      className={classes.actionsButtonGroup}
      data-testid={CalendarModalTestID.ActionButtonsGroup}
    >
      <HtmlTooltip
        title="This calendar will be reconnected to resolve any syncing issues. Your existing appointments will not be deleted."
        arrow
      >
        <Button
          onClick={onSyncClick}
          disabled={working}
          data-testid={CalendarModalTestID.ResyncButton}
        >
          <Replay fontSize="small" className={classes.actionsButtonResyncIcon} />
          &nbsp;Resync
        </Button>
      </HtmlTooltip>
      <HtmlTooltip
        title="This calendar will be disconnected. Your existing appointments will not be deleted."
        arrow
      >
        <Button
          onClick={handleDeleteClick}
          disabled={working}
          data-testid={CalendarModalTestID.DeleteButton}
        >
          <CalendarModalDeleteIcon className={classes.actionsButtonDeleteIcon} />
          &nbsp;Disconnect
        </Button>
      </HtmlTooltip>
    </div>
  );
};
